(function () {
  var config = window.__floramePartnerRuntimeConfig || {};
  var runtimePromise = null;
  var deliveryIntentPromise = null;
  var deliveryIntentPrewarmed = false;
  var directoryPromise = null;
  var directoryStylePromise = null;
  var directoryEpoch = 0;
  var scriptLoads = Object.create(null);

  function hasStoredPartner() {
    try {
      var value = JSON.parse(sessionStorage.getItem('florame_partner_context_v2') || 'null');
      return Boolean(value && (value.partnerSlug || value.partnerId || value.slug));
    } catch (_) {
      return false;
    }
  }

  function hasExplicitPartner() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.has('partner') || params.has('partnerSlug') || params.has('partnerId');
    } catch (_) {
      return false;
    }
  }

  function isGlobalMarketplaceHome() {
    try {
      var path = String(window.location.pathname || '/')
        .replace(/^\/(?:en|it)(?=\/|$)/i, '')
        .replace(/\/+$/, '') || '/';
      return (path === '/' || path === '/pages/home' || path === '/pages/home2' || path === '/home2') && !hasExplicitPartner();
    } catch (_) {
      return false;
    }
  }

  function isPartnerStorefront() {
    var pageTemplate = String(config.pageTemplate || '').trim();
    return document.documentElement.hasAttribute('data-florame-partner-storefront')
      || pageTemplate === 'partner-storefront'
      || /^partner-storefront-v\d+$/.test(pageTemplate);
  }

  function waitForFirstCartItem() {
    var root = document.getElementById('MainContent') || document.body;
    var activated = false;
    function check() {
      if (activated || document.hidden || !root.querySelector('cart-items .cart-item,cart-items .florame-cart-line')) return;
      activated = true; observer?.disconnect();
      document.removeEventListener('visibilitychange', check);
      loadPartnerRuntime().catch(function () {});
    }
    var observer = 'MutationObserver' in window ? new MutationObserver(check) : null;
    function observe() { if (!activated) { observer?.observe(root, {childList:true,subtree:true}); check(); } }
    document.addEventListener('visibilitychange', check);
    window.addEventListener('pagehide', function () { observer?.disconnect(); });
    window.addEventListener('pageshow', observe);
    observe();
  }

  function loadStylesheet(url) {
    if (!url || document.querySelector('link[data-florame-partner-runtime-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.dataset.floramePartnerRuntimeCss = '1';
    document.head.appendChild(link);
  }

  function loadScript(url, id) {
    if (!url) return Promise.resolve();
    if (scriptLoads[id]) return scriptLoads[id];
    var script = document.querySelector('script[data-florame-partner-runtime="' + id + '"]');
    if (script && script.dataset.loaded === '1') return Promise.resolve();
    scriptLoads[id] = new Promise(function (resolve, reject) {
      if (script) script.remove();
      script = document.createElement('script');
      script.src = url;
      // This loader explicitly awaits dependencies. Do not join the browser's
      // document-wide ordered queue behind unrelated, slower dynamic scripts.
      script.async = true;
      script.dataset.floramePartnerRuntime = id;
      var timer = window.setTimeout(function () { finish(false); }, 15000);
      function finish(ok) {
        window.clearTimeout(timer);
        script.onload = script.onerror = null;
        if (ok) { script.dataset.loaded = '1'; resolve(); }
        else { script.remove(); reject(new Error('Unable to load ' + id)); }
      }
      script.onload = function () { finish(true); };
      script.onerror = function () { finish(false); };
      document.head.appendChild(script);
    }).catch(function (error) { delete scriptLoads[id]; throw error; });
    return scriptLoads[id];
  }

  function loadDeliveryIntent() {
    if (window.FlorameDeliveryIntent) return Promise.resolve(window.FlorameDeliveryIntent);
    if (deliveryIntentPromise) return deliveryIntentPromise;
    deliveryIntentPromise = loadScript(config.deliveryPromiseUrl, 'delivery-promise')
      .then(function () { return loadScript(config.deliveryIntentUrl, 'delivery-intent'); })
      .then(function () { return window.FlorameDeliveryIntent || null; })
      .finally(function () {
        if (!window.FlorameDeliveryIntent) deliveryIntentPromise = null;
      });
    return deliveryIntentPromise;
  }

  function prewarmDeliveryIntent() {
    if (deliveryIntentPrewarmed) return;
    deliveryIntentPrewarmed = true;
    loadDeliveryIntent().catch(function () { deliveryIntentPrewarmed = false; });
  }

  function isDeliveryIntentTrigger(target) {
    return Boolean(target && target.closest && target.closest([
      '[data-marketplace-intent]',
      '[data-home-address-trigger]',
      '[data-florame-delivery-intent-summary]',
      '[data-ds-intent-summary]',
      '#dsIntentSetupBtn',
      '[data-open-delivery-intent]'
    ].join(',')));
  }

  async function loadPartnerRuntime() {
    if (runtimePromise) return runtimePromise;
    // Fetch the dependency chain together while preserving execution order below.
    [config.promotionDisplayUrl, config.momentsUrl, config.deliveryPromiseUrl, config.deliveryIntentUrl,
      config.contextUrl, config.availabilityFreshnessUrl, config.analyticsUrl].forEach(function (url) {
      if (!url || Array.prototype.some.call(document.querySelectorAll('link[rel="preload"][as="script"]'), function (link) { return link.href === new URL(url, location.href).href; })) return;
      var preload = document.createElement('link');
      preload.rel = 'preload'; preload.as = 'script'; preload.href = url;
      document.head.appendChild(preload);
    });
    runtimePromise = (async function () {
      if (isPartnerStorefront() || document.querySelector('[data-florame-partner-storefront]')) {
        loadStylesheet(config.cssUrl);
      }
      await Promise.all([
        window.FloramePromotions ? Promise.resolve() : loadScript(config.promotionDisplayUrl, 'promotions'),
        loadScript(config.momentsUrl, 'moments'),
        loadScript(config.deliveryPromiseUrl, 'delivery-promise')
      ]);
      await loadDeliveryIntent();
      await loadScript(config.contextUrl, 'context');
      await loadScript(config.availabilityFreshnessUrl, 'availability-freshness');
      await loadScript(config.analyticsUrl, 'analytics');
      return window.FloramePartner || null;
    })();
    runtimePromise = runtimePromise.catch(function (error) { runtimePromise = null; throw error; });
    return runtimePromise;
  }

  window.__florameLoadPartnerRuntime = loadPartnerRuntime;
  window.__florameLoadDeliveryIntent = loadDeliveryIntent;
  function loadDirectoryStyles() {
    if (!config.directoryCssUrl) return Promise.resolve();
    if (directoryStylePromise) return directoryStylePromise;
    directoryStylePromise = new Promise(function (resolve, reject) {
      var link = document.querySelector('link[data-florame-directory-css],link[href*="florame-partner-directory.css"]');
      var fresh = !link;
      if (!link) { link = document.createElement('link'); link.rel = 'stylesheet'; link.href = config.directoryCssUrl; }
      link.setAttribute('data-florame-directory-styles', '');
      if (link.sheet && link.media !== 'print') { resolve(); return; }
      var timer = setTimeout(function () { finish(false); }, 15000);
      function finish(ok) {
        clearTimeout(timer); link.removeEventListener('load', loaded); link.removeEventListener('error', failed);
        if (ok) resolve();
        else { link.remove(); reject(new Error('directory_styles_unavailable')); }
      }
      function loaded() { finish(true); }
      function failed() { finish(false); }
      link.addEventListener('load', loaded); link.addEventListener('error', failed);
      if (fresh) { link.dataset.florameDirectoryCss = '1'; document.head.appendChild(link); }
    }).catch(function (error) { directoryStylePromise = null; throw error; });
    return directoryStylePromise;
  }
  window.__florameEnsureDirectoryStyles = loadDirectoryStyles;
  window.__florameLoadPartnerDirectory = function () {
    if (directoryPromise) return directoryPromise;
    directoryPromise = Promise.all([loadDirectoryStyles(), (async function () {
      if (window.FloramePartnerDirectory) return;
      if (!window.FloramePromotions) await loadScript(config.promotionDisplayUrl, 'promotions');
      if (!window.FlorameDeliveryPromise) await loadScript(config.deliveryPromiseUrl, 'delivery-promise');
      await loadScript(config.directoryUrl, 'directory');
    })()]).then(function () {
      if (!window.FloramePartnerDirectory?.resolveOffers) throw new Error('directory_runtime_unavailable');
      return window.FloramePartnerDirectory;
    })
      .catch(function (error) { directoryPromise = null; throw error; });
    return directoryPromise;
  };
  var directoryEvents = new WeakSet();
  function requestDirectory(event) {
    if (window.FloramePartnerDirectory?.openCompare || directoryEvents.has(event)) return;
    directoryEvents.add(event);
    var detail = event.detail || {}, epoch = directoryEpoch;
    window.__florameLoadPartnerDirectory().then(function (api) {
      if (epoch !== directoryEpoch || (detail.opener && !detail.opener.isConnected)) return;
      return api?.openCompare?.(detail);
    }).catch(function () {
      if (epoch === directoryEpoch) window.FlorameUI?.toast?.({tone:'error',detail:document.documentElement.lang === 'en' ? 'Cannot open florists. Please try again.' : 'Non riesco ad aprire i fioristi. Riprova.'});
    });
  }
  window.addEventListener('florame:partner-compare-open', requestDirectory);
  document.addEventListener('florame:partner-compare-open', requestDirectory);
  window.addEventListener('pagehide', function () { directoryEpoch++; });
  ['pointerover', 'pointerdown', 'focusin', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (isDeliveryIntentTrigger(event.target)) prewarmDeliveryIntent();
    }, { capture: true, passive: true });
  });
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest?.('[data-create-delivery-fallback]');
    if (!trigger) return;
    loadDeliveryIntent().then(function (intent) { intent?.open({ opener: trigger, source: 'create' }); }).catch(function () {
      window.FlorameUI?.toast?.({ tone: 'error', title: 'Non riesco ad aprire Dove e quando. Tocca per riprovare.' });
    });
  });
  if (document.documentElement.hasAttribute('data-florame-bouquet-collection')) return;
  // Create always needs the shared address/calendar, even without a chosen shop.
  if (/\/(?:pages\/florame-app)\/?$/.test(window.location.pathname)) prewarmDeliveryIntent();
  if (isGlobalMarketplaceHome()) {
    try { sessionStorage.removeItem('florame_partner_context_v2'); } catch (_) {}
    // Restore saved delivery visuals without waiting for the first interaction,
    // including on the production page using the speed-lab loading strategy.
    try {
      var savedAddress = JSON.parse(localStorage.getItem('florame_cap_state') || '{}');
      if (savedAddress.verified === true || savedAddress.addressVerified === true) { prewarmDeliveryIntent(); return; }
    } catch (_) {}
    // With no verified saved address, the hero already renders its empty
    // fields. Prepare the calendar on focus/touch instead of during startup.
  } else if (/\/(?:cart)\/?$/.test(window.location.pathname) && !hasExplicitPartner() && !hasStoredPartner()
    && document.querySelector('cart-items.is-empty') && 'MutationObserver' in window) {
    // No address, florist or pricing UI is visible in a fresh empty cart. Keep
    // all explicit loaders available and activate on the first Shopify update.
    waitForFirstCartItem();
  } else if (isPartnerStorefront() || hasExplicitPartner() || hasStoredPartner() || /\/(?:cart)\/?$/.test(window.location.pathname) || /\/products\//.test(window.location.pathname)) {
    loadPartnerRuntime().catch(function () { /* A customer action can retry the dependency chain. */ });
  }
})();
